import Component from '../core/Component'
import EventBus from '../core/EventBus'
import { Events as SwupEvents } from '../services/Swup'
import { Events as SectionEvents } from './Section'

export default class NavigationOpener extends Component {
    constructor(element) {
        super(element)

        this.state = {
            timer: null,
            enterTime: 0,
        }
    }
    prepare() {
        this.element.addEventListener('click', this.handleClick)
        EventBus.on(SectionEvents.Enter, this.handleSectionEnter)
        EventBus.on(SectionEvents.Leave, this.handleSectionLeave)
        EventBus.on(SwupEvents.ContentReplaced, this.handleContentReplaced)
    }

    destroy() {
        this.element.removeEventListener('click', this.handleClick)
        EventBus.off(SectionEvents.Enter, this.handleSectionEnter)
        EventBus.off(SectionEvents.Leave, this.handleSectionLeave)
        EventBus.off(SwupEvents.ContentReplaced, this.handleContentReplaced)
        this.element.classList.remove('is-dark', 'is-light')
    }

    handleSectionEnter = ({ type }) => {
        this.state.enterTime = Date.now()
        this.render(type)
    }

    handleSectionLeave = ({ type }) => {
        // ignore if the section was entered less than 100ms ago
        if (Date.now() - this.state.enterTime < 100) {
            return
        }

        this.state.timer = setTimeout(() => {
            this.reset()
        }, 100)
    }

    handleContentReplaced = () => {
        this.reset()
    }

    handleClick = () => {
        const navigation = Component.getFromElement(
            document.querySelector('[data-component="Navigation"]'),
        )

        if (navigation) {
            navigation.toggle()
        }
    }

    render(type) {
        if (this.state.timer) {
            clearTimeout(this.state.timer)
        }

        this.element.classList.toggle('is-dark', type === 'light')
        this.element.classList.toggle('is-light', type === 'dark')
    }

    reset() {
        this.element.classList.remove('is-dark', 'is-light')
    }
}
